import { getMessage } from '@tcc/i18n';
import type { Nullable } from '@tcc/common';
import type { ReportMeasurement } from '../../../../types';
import { isByRangeDimensionItem, isBySeedProductItem, isDateDimensionItem, isYieldRegionReport } from '../../../../types';
import { formatLocalDate, isValidDate, toIsoDateOnly } from '../../../../utils/dateHelpers';
import { RootLevelDetails } from '../container/types/modals';

export interface DisplayItem {
  averageYield: Nullable<ReportMeasurement>;
  area: Nullable<ReportMeasurement>;
  label: string;
  cropNominalWeight?: Nullable<ReportMeasurement>;
}

export const getDisplayItem = (dataItem: RootLevelDetails): DisplayItem => {
  if (isYieldRegionReport(dataItem)) {
    return {
      averageYield: dataItem.averageYield,
      area: dataItem.area,
      label: dataItem.label,
    };
  }

  if (isBySeedProductItem(dataItem)) {
    return {
      averageYield: dataItem.stats.stdYield,
      area: dataItem.stats.harvestedArea,
      label: dataItem.seedProduct.name || getMessage('legend.unknown'),
      cropNominalWeight: dataItem.stats.nominalWeight
    };
  }

  if(isDateDimensionItem(dataItem)) {
    let date = '';
    if(dataItem.date !== null && isValidDate(dataItem.date)) {
      const localIsoDate = toIsoDateOnly(dataItem.date)
      date = localIsoDate ? formatLocalDate(localIsoDate) : '';
    }

    return {
      averageYield: dataItem.stats.stdYield,
      area: dataItem.stats.harvestedArea,
      label: date || '',
      cropNominalWeight: dataItem.stats.nominalWeight
    };
  }

  if(isByRangeDimensionItem(dataItem)) {
    const items:number[] = [];

    if(dataItem.min !== null) {
      items.push(dataItem.min);
    }

    if(dataItem.max !== null) {
      items.push(dataItem.max);
    }

    return {
      averageYield: dataItem.stats.stdYield,
      area: dataItem.stats.harvestedArea,
      label: `${items.join(' - ')} ${dataItem.units ?? ''}`.trim(),
      cropNominalWeight: dataItem.stats.nominalWeight
    };
  }

  return {
    averageYield: null,
    area: null,
    label: ''
  };
};